import {Component, OnDestroy, OnInit} from '@angular/core';
import {ButtonClassesEnum, IButtonModel,} from '@types-custom/models/ui/button-model';
import {Icon} from '@types-custom/models/ui/icon-model';
import {ODMatrizService} from "@shared/services/odmatriz-service/odmatriz.service";
import {ODMatrixFilteredTypesEnum} from "@shared/models/ODMatrix/ODMatrix.model";
import { MatrixODCameraService } from '@shared/services/matrizOD-camera-service/matrix-od-camera.service';
import { AnyARecord } from 'dns';

@Component({
  selector: 'cdm-almeria-map-filter-matrix-od-camera',
  templateUrl: './map-filter-matrix-od-camera.component.html',
  styleUrls: ['./map-filter-matrix-od-camera.component.scss'],
})

export class MapFilterMatrixODCameraComponent implements OnInit {
  Icon=Icon;
  buttonTag = 'BUSCAR';
  buttonAttributes: IButtonModel = {};
  restorebuttonAttributes: IButtonModel = {};
  applybuttonAttributes : IButtonModel = {};

  firstFilter = 'origin';
  percentageFilters : any = [{ label: "Todos", min: 0, max: 100 }]

  SelectedFilterOptions : any[] = []


  ngOnInit(): void {
    this.generateButtonAttributes();
    this.generateRangeOfPercentageButtons();
  }

  constructor(
    private ODMatrixService : MatrixODCameraService
  ) {
  }

  private generateButtonAttributes(): void {
    this.restorebuttonAttributes = {
      label: 'RESTABLECER',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.transparent_button_2_custom,
      },
    };
    this.applybuttonAttributes = {
      label: 'APLICAR',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.primary_1_button_filter_custom,
      },
    };
  }
  private generateRangeOfPercentageButtons() {

    this.SelectedFilterOptions = [
      { label: "00% - 10%", min: 0, max: 10 },
      { label: "11% - 20%", min: 11, max: 20 },
      { label: "21% - 30%", min: 21, max: 30 },
      { label: "31% - 40%", min: 31, max: 40 },
      { label: "41% - 50%", min: 41, max: 50 },
      { label: "51% - 60%", min: 51, max: 60 },
      { label: "61% - 70%", min: 61, max: 70 },
      { label: "71% - 80%", min: 71, max: 80 },
      { label: "81% - 90%", min: 81, max: 90 },
      { label: "91% - 100%", min: 91, max: 100 },
      { label: "Todos", min: 0, max: 100 }
    ];

    this.reloadData();
  }

  public selectPercentage(item : any) {
    if(item.label === 'Todos' || (this.percentageFilters.length >= (this.SelectedFilterOptions.length - 1)) ) {
      this.selectAllPercentages();
    }
    else {
      if(document.getElementById('Todos').classList.contains('active')) {
        document.getElementById('Todos').classList.remove('active')
        this.percentageFilters = []
      }

      let elem = document.getElementById(item.label);

      if (elem.classList.contains('active')) {
        elem.classList.remove('active')
        // this.percentageFilters.splice(this.percentageFilters.indexOf(id),1)
      }
      else {
        elem.classList.add('active')
        this.percentageFilters = item
      }
    }
  }

  private selectAllPercentages() {
    this.percentageFilters.forEach((e:any) => {
      document.getElementById((e.label)).classList.remove('active')
    })

    let item = document.getElementById('Todos')

    if (item.classList.contains('active')) {
      item.classList.remove('active')
      this.percentageFilters = []
    }
    else {
      item.classList.add('active')
      this.percentageFilters = [  { label: "Todos", min: 0, max: 100 }]
    }
  }

  // public selectTypeMatrix(id : string) {
  //   (id === 'origin') ? this.removeClass('destination') : this.removeClass('origin')
  //   document.getElementById(id).classList.add('active')
  //   this.firstFilter = id
  // }
  private removeClass(id : string) {
    document.getElementById(id).classList.contains('active') ?
      document.getElementById(id).classList.remove('active') :
      null
  }

  public sendValues(type : boolean) {
    if(type) {
      this.percentageFilters =  { label: "Todos", min: 0, max: 100 }
      // this.selectTypeMatrix('origin')
    }

    document.querySelector<HTMLElement>('#Matriz').click();

    (type) ? document.querySelector<HTMLElement>('#Matriz').parentElement.classList.remove('applied-filter') :
             document.querySelector<HTMLElement>('#Matriz').parentElement.classList.add('applied-filter');

    this.ODMatrixService.cameraFilter.next(
      {
              type : ODMatrixFilteredTypesEnum.CAMERA_FILTER,
              values : {
                percentage : this.percentageFilters
              }
            }
    )
  }

  private reloadData() {
    this.ODMatrixService.dataCamerFilter$.subscribe((res : any) => {
      if(res?.type === ODMatrixFilteredTypesEnum.CAMERA_FILTER) {
        this.percentageFilters = res.values.percentage
        this.firstFilter = res.values.direction
      }
    })
  }

  ExitsOnArray(item: any) {
    return (this.percentageFilters.find((e:any) => {return e.label === item.label}))
  }
}
